export default {"API_ENDPOINT":"https://api.fitearn.app/live-fit"}